import { render } from "./goaltracking-model.vue?vue&type=template&id=a8ef3c7a"
import script from "./goaltracking-model.vue?vue&type=script&lang=js"
export * from "./goaltracking-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__